function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .logout-cls-1{fill:#2a343f}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_4483",
  "data-name": "Group 4483",
  transform: "translate(-.463 -1.122)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4190",
  "data-name": "Path 4190",
  className: "logout-cls-1",
  d: "M12.51 17.2h3.348v4.069a1 1 0 0 0 2 0V17.2h1.754v2.379a1 1 0 0 0 2 0V17.2H23.8a1 1 0 0 0 0-2H12.51a6.069 6.069 0 1 0 0 2zm-10.047-1a4.069 4.069 0 1 1 4.068 4.069A4.073 4.073 0 0 1 2.463 16.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4191",
  "data-name": "Path 4191",
  className: "logout-cls-1",
  d: "M16.858 1.122A15.124 15.124 0 0 0 5.8 5.957a1 1 0 1 0 1.463 1.359 13.078 13.078 0 1 1-.317 17.413 1 1 0 0 0-1.515 1.305A15.077 15.077 0 1 0 16.858 1.122z"
}));

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.474,
    height: 30.156,
    viewBox: "0 0 31.474 30.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.fca0507c.svg";
export { ForwardRef as ReactComponent };